import React, { createContext, useContext, useState } from 'react';

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(() => {
    const saved = localStorage.getItem('profile');
    // Ensure favoriteItems is always an array
    return saved
      ? { favoriteItems: [], ...JSON.parse(saved) }
      : { address: '', phone: '', name: '', favoriteItems: [] };
  });

  const updateProfile = (updates) => {
    setProfile(prev => {
      const updated = { ...prev, ...updates };
      localStorage.setItem('profile', JSON.stringify(updated));
      return updated;
    });
  };

  // Add to favorites
  const addToFavorites = (item) => {
    setProfile(prev => {
      // Prevent duplicates
      const exists = (prev.favoriteItems || []).some(fav => fav.id === item.id);
      if (exists) return prev;
      const updated = {
        ...prev,
        favoriteItems: [...(prev.favoriteItems || []), item]
      };
      localStorage.setItem('profile', JSON.stringify(updated));
      return updated;
    });
  };

  // Remove from favorites
  const removeFromFavorites = (itemId) => {
    setProfile(prev => {
      const updated = {
        ...prev,
        favoriteItems: (prev.favoriteItems || []).filter(item => item.id !== itemId)
      };
      localStorage.setItem('profile', JSON.stringify(updated));
      return updated;
    });
  };

  return (
    <ProfileContext.Provider
      value={{
        profile,
        updateProfile,
        addToFavorites,
        removeFromFavorites
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);